import { NgModule } from '@angular/core';

// Material Modules
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatTableModule } from '@angular/material/table';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatMenuModule } from '@angular/material/menu';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatDividerModule } from '@angular/material/divider';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatListModule } from '@angular/material/list';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatInputModule } from '@angular/material/input';
import { MatDialogModule } from '@angular/material/dialog';
import { MatSelectModule } from '@angular/material/select';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatRadioModule } from '@angular/material/radio';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatStepperModule } from '@angular/material/stepper';
import { MatCardModule } from '@angular/material/card';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatChipsModule } from '@angular/material/chips';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatSortModule } from '@angular/material/sort';
import { CdkAccordionModule } from '@angular/cdk/accordion';

// Third-party UI modules
import { NgxMaterialTimepickerModule } from 'ngx-material-timepicker';
import { CarouselModule } from 'primeng/carousel';
import { TagModule } from 'primeng/tag';

const MATERIAL_MODULES = [
  MatSnackBarModule,
  MatSidenavModule,
  MatTableModule,
  MatTooltipModule,
  MatMenuModule,
  MatToolbarModule,
  MatIconModule,
  MatButtonModule,
  MatButtonToggleModule,
  MatDividerModule,
  MatListModule,
  MatFormFieldModule,
  MatSlideToggleModule,
  MatInputModule,
  MatDialogModule,
  MatSelectModule,
  MatDatepickerModule,
  MatCheckboxModule,
  MatRadioModule,
  MatGridListModule,
  MatStepperModule,
  MatCardModule,
  MatProgressBarModule,
  MatProgressSpinnerModule,
  MatChipsModule,
  MatExpansionModule,
  MatSortModule,
  CdkAccordionModule,
  NgxMaterialTimepickerModule,
  CarouselModule,
  TagModule,
];

@NgModule({
  imports: [
    ...MATERIAL_MODULES,
    NgxMaterialTimepickerModule.setOpts('de'),
  ],
  exports: [
    ...MATERIAL_MODULES,
  ],
})
export class MaterialModule {}
